import { render } from "./BreadcrumbItem.vue?vue&type=template&id=a0ddad9c"
import script from "./BreadcrumbItem.vue?vue&type=script&lang=js"
export * from "./BreadcrumbItem.vue?vue&type=script&lang=js"
script.render = render

export default script